"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M16.23 7h4.12L10.5 2 2 6.21V17h2V7.4L10.5 4z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M5 8v13h17V8zm15 4-6.5 3.33L7 12v-2l6.5 3.33L20 10z"
}, "1")], 'MarkAsUnreadSharp');